import React from 'react';
import theme from './OptionConfiguratorMainStyle.module.scss';
import { useParams } from 'react-router';
import { StyleCard } from '../StyleCard';
import { useOptionConfigurator } from '../OptionConfiguratorContext';
import { MarkdownDisplay } from '@ygtechnologies/bygr-frontend-component-library';
import { Card } from '@ygtechnologies/rubus-ui';

export interface OptionConfiguratorMainStyleProps { }

export const OptionConfiguratorMainStyle: React.FC<OptionConfiguratorMainStyleProps> = ({ }) => {
    const { styleGroupId } = useParams<{ styleGroupId: string }>();
    const { configuratorData } = useOptionConfigurator();
    const styleGroup = configuratorData?.styleGroups.find((x) => x.id === Number(styleGroupId));

    return (
        <Card className={theme.mainStyleContainer}>
            <div>
                <h2>{styleGroup?.name}</h2>
                <MarkdownDisplay className={theme.description} markdown={styleGroup?.description || ''} />
            </div>

            {styleGroup?.styles.map((style) => (
                <StyleCard key={style.id} style={style} styleGroup={styleGroup} />
            ))}
        </Card>
    );
};
